import moment from "moment";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import deliveredIcon from "./delivered-64px.png";
import onAWayIcon from "./fast-delivery-64px.png";
import notDeliveredIcon from "./not-delivered-64px.png";

import palette from "../theme/palette";

const orderStatusTranslationConformity = {
	ON_A_WAY: <img src={onAWayIcon} alt="В ДОРОЗІ" height="40" />,
	DELIVERED: <img src={deliveredIcon} alt="ДОСТАВЛЕНО" height="40" />,
	UNDELIVERED: <img src={notDeliveredIcon} alt="НЕ ДОСТАВЛЕНО" height="40" />,
};

const OrderNumberCopied = ({ orderNumber }) => {
	const [isSnackbarOpen, setSnackbarOpen] = useState(false);

	const handleTextClick = async () => {
		try {
			await navigator.clipboard.writeText(orderNumber);
			setSnackbarOpen(true);
		} catch (err) {
			console.error("Failed to copy text: ", err);
		}
	};
	const handleCloseSnackbar = () => {
		setSnackbarOpen(false);
	};
	return (
		<div>
			<Box
				sx={{
					padding: "5px",
					cursor: "pointer",
					"&:hover": {
						backgroundColor: palette.grey[300],
					},
				}}
				onClick={handleTextClick}
			>
				{orderNumber}
			</Box>

			<Snackbar
				open={isSnackbarOpen}
				autoHideDuration={3000}
				onClose={handleCloseSnackbar}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity="success"
					sx={{ width: "100%" }}
				>
					Номер накладної успішно скопійовано!
				</Alert>
			</Snackbar>
		</div>
	);
};

const Driver = ({ driver, showDriverLocation }) => {
	// TODO: get is expanded data from query params
	const [isExpanded, setIsExpanded] = useState(false);
	const clients = [...new Set(driver.orders.map((o) => o.clientName))];
	const clientOrders = (client) =>
		driver.orders.filter((o) => o.clientName === client);
	return (
		<Accordion
			sx={{
				minWidth: "300px",
				"& Mui-Accordion .Mui-expanded": {
					margin: "0px",
				},
				// borderStyle: "solid",
				borderColor: isExpanded ? palette.primary.light : "white",
			}}
			disableGutters={true}
			expanded={isExpanded}
			onChange={() => setIsExpanded(!isExpanded)}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="map-driver-card"
				id="map-driver-card"
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						gap: 1,
						width: "100%",
						marginRight: 1,
					}}
				>
					<Typography>{driver.car.model + " " + driver.car.number}</Typography>
					<LocationOnIcon
						fontSize="medium"
						sx={{
							borderStyle: "solid",
							color: palette.primary.main,
							borderRadius: 2,
							borderColor: palette.primary.dark,
						}}
						onClick={() => showDriverLocation(driver.id)}
					/>
				</Box>
			</AccordionSummary>
			<AccordionDetails
				sx={{
					"& MuiAccordionDetails-root": {
						margin: "0px",
					},
					// borderStyle: "solid",
					// borderColor: isExpanded ? palette.primary.light : "white",
				}}
			>
				<Box sx={{ width: "auto" }}>
					{[...new Set(driver.orders.map((o) => o.clientName))].map(
						(client, i) => (
							<Box key={i}>
								{" "}
								<Box sx={{ textAlign: "center", background: "#dcdcdd" }}>
									{client}
								</Box>
								<Box sx={{ paddingLeft: "5px" }}>
									{clientOrders(client).map((order) => (
										<Box
											sx={{
												display: "flex",
												justifyContent: "space-between",
												alignItems: "center",
											}}
										>
											<OrderNumberCopied orderNumber={order.orderNumber} />
											<Box sx={{ fontSize: "12px", color: palette.grey[600] }}>
												{moment(order.date).format("HH:mm DD MMM")}
											</Box>
											<Box sx={{}}>
												{orderStatusTranslationConformity[order.status]}
											</Box>
										</Box>
									))}
								</Box>
							</Box>
						)
					)}
				</Box>
				{/* <List dense={dense}>
					{[...new Set(driver.orders.map((o) => o.clientName))].map(
						(client, i) => (
							<ListItem key={i}>
								<ListItemText
									primary={`${i}. ` + client}
									secondary={"Secondary textэ"}
								/>
							</ListItem>
						)
					)}
				</List> */}
				{/* {driver.orders.map((clOrders, i) => (
          
					// <Chip key={i} label={clOrders[0].clientName} color="primary" variant="outlined" />
				))} */}
			</AccordionDetails>
		</Accordion>
	);

	// if (isActive) {
	// 	return (
	// 		<div
	// 			className="driver active"
	// 			style={{
	// 				width: 200,
	// 				// height: 50,
	// 				border: "1px solid black",
	// 				margin: 10,
	// 				display: "flex",
	// 				alignItems: "center",
	// 				justifyContent: "center",
	// 				cursor: "pointer",
	// 				height: "auto",
	// 				flexDirection: "column",
	// 			}}
	// 		>
	// 			<div
	// 				className="close"
	// 				style={{
	// 					alignSelf: "flex-start",
	// 					cursor: "pointer",
	// 					margin: 5,
	// 				}}
	// 				onClick={() => setIsActive(false)}
	// 			>
	// 				---
	// 			</div>
	// 			{driver.orders.flat().map((order, idx) => (
	// 				<div
	// 					key={idx}
	// 					className="client"
	// 					style={{
	// 						width: "100%",
	// 						height: 50,
	// 						borderTop: "1px solid black",
	// 						display: "flex",
	// 						alignItems: "center",
	// 						justifyContent: "center",
	// 					}}
	// 				>
	// 					{order.clientName}
	// 				</div>
	// 			))}
	// 		</div>
	// 	);
	// }

	// return (
	// 	<div
	// 		className="driver"
	// 		style={{
	// 			width: 200,
	// 			// height: 50,
	// 			border: "1px solid black",
	// 			margin: 10,
	// 			display: "flex",
	// 			alignItems: "center",
	// 			justifyContent: "center",
	// 			cursor: "pointer",
	// 		}}
	// 		onClick={() => setIsActive(true)}
	// 	>
	// 		{driver.car.name}
	// 	</div>
	// );
};

export default Driver;
